import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getGames = () => {
  return axios.get(`${getBackendUrl()}/games`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addGame = (game) => {
  return axios.put(
    `${getBackendUrl()}/game`,
    game,
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const removeGame = (id) => {
  return axios.delete(`${getBackendUrl()}/game/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const uploadGameImage = (id, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${getBackendUrl()}/game/${id}/image`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};